import {cs}          from "./chain-services";
import {fragments}   from "./fragments";
import {Invoke}      from "./invoke";
import {TimedAction} from "./timed-action";
import {UseState}    from "./use-state";

export const IntervalReload = ({fetch, continueCondition, delay=3100, next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => fragments(
        next({value: state.value?.value}),

        !state.value && (
            Invoke({
                fn: async () => {
                    const result = await fetch();
                    state.onChange({value: result, time: Date.now()});
                },
            })
        ),
        state.value && continueCondition(state.value.value) && (
            TimedAction({
                action: async () => {
                    const result = await fetch();
                    state.onChange({value: result, time: Date.now()});
                },
                time: state.value.time + delay,
            })
        )
    ),
);